import { supabase } from '../config/supabase.js'

// Cloudflare R2 Configuration
const R2_BUCKET_URL = import.meta.env.VITE_R2_BUCKET_URL
const R2_ACCESS_KEY = import.meta.env.VITE_R2_ACCESS_KEY
const R2_SECRET_KEY = import.meta.env.VITE_R2_SECRET_KEY
const R2_BUCKET_NAME = import.meta.env.VITE_R2_BUCKET_NAME

// Upload file to Cloudflare R2
export const uploadToR2 = async (file, folder = 'images') => {
  try {
    const fileName = `${folder}/${Date.now()}-${file.name}`
    const formData = new FormData()
    formData.append('file', file)
    formData.append('key', fileName)

    // For now, we'll use Supabase storage as a fallback
    // You can replace this with actual R2 upload later
    const { data, error } = await supabase.storage
      .from('gym-assets')
      .upload(fileName, file)

    if (error) throw error

    const { data: { publicUrl } } = supabase.storage
      .from('gym-assets')
      .getPublicUrl(fileName)

    return {
      url: publicUrl,
      path: fileName
    }
  } catch (error) {
    console.error('Error uploading to R2:', error)
    throw error
  }
}

// Delete file from Cloudflare R2
export const deleteFromR2 = async (path) => {
  try {
    const { error } = await supabase.storage
      .from('gym-assets')
      .remove([path])

    if (error) throw error
    return true
  } catch (error) {
    console.error('Error deleting from R2:', error)
    throw error
  }
}